import { debounce } from 'lodash';

export function Debounce(delay = 0, options: any = {}): MethodDecorator {
  return function (
    target: any,
    propertyKey: string,
    descriptor: PropertyDescriptor
  ) {
    const original = descriptor.value;
    descriptor.value = debounce(original, delay, options);
    return descriptor;
  };
}
